import { useState, useRef, useMemo, useContext } from "react"
import { UserContext } from "../../store/store"
import { api } from "../../services/api"
import { getCookie } from "../../helpers/cookies"
import { ModalError } from "../../components/ui/modal/ModalError"
import { ModalOk } from "../../components/ui/modal/ModalOk"
import { msg } from "../../components/ui/modal/utils"
import useFetch from "../../hooks/useFetch"
import { ModalEditarUsuario } from "../../components/admin/ModalEditarUsuario"
import { ModalEliminarUsuario } from "../../components/admin/ModalEliminarUsuario"
import { useQuery } from "../../hooks/useQuery"
import { Trans, useTranslation } from "react-i18next"

export const CrearUsuario = () => {
  const roles = ["admin", "teacher"]

  // el's
  const form = useRef()

  // estado
  const [username, setUsername] = useState(""),
    [pass, setPass] = useState(""),
    [role, setRol] = useState("admin")

  const createUser = useQuery(),
    showRes = useState(false)

  const cleanForm = () => {
    form.current.reset()
    setUsername("")
    setPass("")
    setRol("admin")
  }

  const onSubmitForm = async (e) => {
    e.preventDefault()
    showRes[1](true)

    const { url, opt } = await api.users.postUser({
      token: getCookie("jwt"),
      rawPassword: pass,
      username,
      role,
    })

    createUser.url.current = url
    createUser.opt.current = opt

    createUser.run({
      onOk: () => {
        cleanForm()
      },
    })
  }

  const { t } = useTranslation()

  return (
    <>
      {createUser.res && !createUser.err && (
        <ModalOk
          show={showRes}
          body={msg(
            <Trans
              i18nKey="admin.users.user_succesfully_added"
              values={{ name: username }}
              components={{ i: <i /> }}
            />
            // <>El usuario <b>{username}</b> ha sido creado con éxito.</>
          )}
        />
      )}

      {createUser.res && createUser.err && (
        <ModalError id="err-res" show={showRes} res={createUser.res} />
      )}

      {/* formulario */}
      <div className="col-6" style={{ margin: "0 auto" }}>
        <form ref={form}>
          <fieldset>
            <legend>{t(`admin.users.new_user`)}</legend>

            <div className="form-group">
              <label className="form-label mt-4">
                {t(`admin.users.username`)}
              </label>
              <div className="input-group mb-3">
                <span className="input-group-text">@</span>
                <input
                  onChange={(e) => setUsername(e.target.value)}
                  className="form-control"
                  placeholder={t(`admin.users.placeholder_username`)}
                />
              </div>
              <small className="form-text text-muted">
                {t(`admin.users.no_spaces`)}
              </small>
            </div>

            <div className="form-group">
              <label className="form-label mt-4">
                {t(`admin.users.password`)}
              </label>
              <input
                onChange={(e) => setPass(e.target.value)}
                type="password"
                className="form-control"
                placeholder={t(`admin.users.password`)}
              />
            </div>

            <div className="form-group">
              <label className="form-label mt-4">
                {t(`admin.users.user_rol`)}
              </label>
              <select
                className="form-select"
                onChange={(e) => setRol(e.target.value)}
              >
                {roles.map((role, ix) => (
                  <option key={ix} value={role}>
                    {role}
                  </option>
                ))}
              </select>
            </div>

            <button
              onClick={onSubmitForm.bind(this)}
              disabled={createUser.isPending}
              type="submit"
              className="btn btn-primary mt-5"
            >
              {createUser.isPending
                ? t(`ui.btns.submiting`) + "..."
                : t(`ui.btns.create`)}
            </button>
          </fieldset>
        </form>
      </div>
    </>
  )
}

export const GestionarUsuarios = () => {
  const token = getCookie("jwt")
  const { url, opt } = useMemo(() => api.users.getAll({ token }), [token])
  const [data, isPending, err, setData] = useFetch({ url, opt })

  const modalEditar = useState(false),
    modalEliminar = useState(false),
    [editId, setEditId] = useState(null)

  const onClickEditar = (user_id, e) => {
    e.preventDefault()
    modalEditar[1](true)
    setEditId(user_id)
  }

  const onClickEliminar = (usr, e) => {
    e.preventDefault()
    setEditId(usr)
    modalEliminar[1](true)
  }

  const { t } = useTranslation()

  const ListUsers = (users) => {
    const [state] = useContext(UserContext)
    const theme = state.theme === "light" ? "table-striped" : "table-dark"

    return (
      <table className={"table table-hover w-100 " + theme}>
        <thead>
          <tr>
            <th>ID</th>
            <th>{t(`admin.users.username`)}</th>
            <th>{t(`admin.users.rol`)}</th>
            <th>
              <center>{t(`ui.tables.edit`)}</center>
            </th>
            <th>
              <center>{t(`ui.tables.delete`)}</center>
            </th>
          </tr>
        </thead>
        <tbody style={{ borderTop: "2px solid #4e4e4e" }}>
          {users.map((usr, ix) => (
            <tr key={ix}>
              <td>{usr.user_id}</td>
              <td>{usr.username}</td>
              <td>{usr.role}</td>
              <td>
                <center>
                  <button
                    type="button"
                    onClick={onClickEditar.bind(this, usr.user_id)}
                    className="btn btn-sm tooltip edit-tooltip"
                  >
                    ✏️
                  </button>
                </center>
              </td>
              <td>
                <center>
                  <button
                    type="button"
                    onClick={onClickEliminar.bind(this, usr)}
                    className="btn btn-sm tooltip elim-tooltip"
                  >
                    ❌
                  </button>
                </center>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    )
  }

  return (
    <>
      {modalEditar[0] && (
        <ModalEditarUsuario
          show={modalEditar}
          user_id={editId}
          setUsers={setData}
        />
      )}

      {modalEliminar[0] && (
        <ModalEliminarUsuario
          show={modalEliminar}
          user={editId}
          setUsers={setData}
        />
      )}

      <div className="col-lg-8 col-12" style={{ margin: "0 auto" }}>
        <h2 className="mb-4">{t(`admin.users.users`)}</h2>
        {isPending && <p className="my-3">{t(`ui.btns.loading`)}...</p>}
        {err && <p className="my-3">{t(`ui.msgs.something_went_wrong`)}</p>}
        {!isPending && data && ListUsers(data)}
      </div>
    </>
  )
}
